export function NoAccess() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center" data-testid="fleetcare-no-access">
      <p className="text-sm text-slate-500 max-w-md">Your role does not have access to this module.</p>
    </div>
  );
}
